module.exports = __webpack_public_path__ + "img/logo.972e4642.svg";